import styled from 'styled-components';

const StepsDescription = styled.span`
&&& {
    ${({ theme }) => theme.TextStyles.span.Text14EmphasisLeft};
}
`;

export default StepsDescription;
